<template>
  <div class="contai_h">
    <!-- 断当回收 -->
    <div class="cont_box">
      <!-- 标题 -->
      <div class="cont_head">
        <h2>回收订单复核</h2>
        <h2>建档日期:{{ deta }}</h2>
      </div>
      <!-- 分割线 -->
      <div class="bord"></div>
      <!-- 线框 -->
      <div class="cont_bo">
        <div class="cont_b">
          <!-- 新回收复核页面 -->
          <div class="cont_contes">
            <table width="100%">
              <tr height="50px">
                <!-- 第一栏 -->
                <td width="15%">票号</td>
                <td>
                  <input type="text" v-model="input_pnum" />
                </td>
                <td width="15%">电话</td>
                <td>
                  <input type="text" v-model="input_tels" />
                </td>
              </tr>
              <!-- 第二栏 -->
              <tr height="50px">
                <td width="15%">当户</td>
                <td>
                  <input type="text" v-model="input_names" />
                </td>
                <td width="15%">物品类型</td>
                <td>
                  <input type="text" v-model="input_wus" />
                </td>
              </tr>

              <!-- 第三栏 -->
              <tr height="50px">
                <td width="15%">地址</td>
                <td>
                  <input type="text" v-model="input_adds" />
                </td>
                <td width="15%">证件号码</td>
                <td>
                  <input type="text" v-model="input_idcards" />
                </td>
              </tr>
            </table>

            <!-- 物品栏 -->
            <table width="100%">
              <!-- 第一栏 -->
              <tr height="80px">
                <td width="5%">当物名称</td>
                <td>
                  <input type="text" v-model="tabs_inputs" />
                </td>
                <td width="5%">规格/种类</td>
                <td>
                  <input type="text" v-model="tabs_inpus" />
                </td>
                <td width="5%">数量</td>
                <td>
                  <input type="text" v-model="tabs_inps" />
                </td>
                <td width="5%">重量/g</td>
                <td>
                  <input type="text" v-model="tabs_ins" />
                </td>
                <td width="5%">回收价格</td>
                <td>
                  <input type="text" v-model="tabs_is" />
                </td>
                <td width="5%">上交所单价</td>
                <td>
                  <input type="text" v-model="reaprice1" />
                </td>
                <td width="5%">回收单价</td>
                <td>
                  <input type="text" v-model="hpria" />
                </td>
                <td width="5%">折当率/%</td>
                <td>
                  <input type="text" v-model="hs_ze" />
                </td>
              </tr>

              <!-- 第二栏 -->
              <tr height="80px">
                <td width="5%">当物名称</td>
                <td>
                  <input type="text" v-model="tabs_inputsa" />
                </td>
                <td width="5%">规格/种类</td>
                <td>
                  <input type="text" v-model="tabs_inpusa" />
                </td>
                <td width="5%">数量</td>
                <td>
                  <input type="text" v-model="tabs_inpsa" />
                </td>
                <td width="5%">重量/g</td>
                <td>
                  <input type="text" v-model="tabs_insa" />
                </td>
                <td width="5%">回收价格</td>
                <td>
                  <input type="text" v-model="tabs_isa" />
                </td>
                <td width="5%">上交所单价</td>
                <td>
                  <input type="text" v-model="reaprice2" />
                </td>
                <td width="5%">回收单价</td>
                <td>
                  <input type="text" v-model="hprib" />
                </td>
                <td width="5%">折当率/%</td>
                <td>
                  <input type="text" v-model="hs_zea" />
                </td>
              </tr>

              <!-- 第三栏 -->
              <tr height="80px">
                <td width="5%">当物名称</td>
                <td>
                  <input type="text" v-model="tabs_inputsaa" />
                </td>
                <td width="5%">规格/种类</td>
                <td>
                  <input type="text" v-model="tabs_inpusaa" />
                </td>
                <td width="5%">数量</td>
                <td>
                  <input type="text" v-model="tabs_inpsaa" />
                </td>
                <td width="5%">重量/g</td>
                <td>
                  <input type="text" v-model="tabs_insaa" />
                </td>
                <td width="5%">回收价格</td>
                <td>
                  <input type="text" v-model="tabs_isaa" />
                </td>
                <td width="5%">上交所单价</td>
                <td>
                  <input type="text" v-model="reaprice3" />
                </td>
                <td width="5%">回收单价</td>
                <td>
                  <input type="text" v-model="hpric" />
                </td>
                <td width="5%">折当率/%</td>
                <td>
                  <input type="text" v-model="hs_zeaa" />
                </td>
              </tr>
              <tr height="90px">
                <td>备注</td>
                <td colspan="15">
                  <input type="text" v-model="inputzf" />
                </td>
              </tr>
            </table>
          </div>

          <!-- 经办信息 -->
          <div class="cont_jb">
            <span
              ><h3>经办人：{{ agent }}</h3></span
            >

            <!-- 复核 -->
            <span class="cont_jbs">
              <h3>复核：{{ review }}</h3>
            </span>

            <!-- 财务 -->
            <span class="cont_jbs">
              <h3>财务：{{ finance }}</h3>
            </span>
          </div>

          <!-- 提交按钮 -->
          <div class="foter">
            <el-button type="primary" @click="cont_Submits">复核提交</el-button> 
        
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import util from "@/components/util";
export default {
  name: "take",
  data() {
    return {
      id: "", //被点击的订单的id
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      input_pnum: "", //票号
      input_names: "", // 当户姓名
      input_adds: "", //证件地址
      input_idcards: "", //证件号码

      input_tels: "", //电话
      input_wus: "", //物品类型

      tabs_inpus: "", //第一栏规格种类
      tabs_inpusa: "", //第二栏规格种类
      tabs_inpusaa: "", //第三栏规格种类

      tabs_inps: "", //第一栏数量
      tabs_inpsa: "", //第二栏数量
      tabs_inpsaa: "", //第三栏数量

      tabs_ins: "", //第一栏重量
      tabs_insa: "", //第二栏重量
      tabs_insaa: "", //第三栏重量

      tabs_is: "", //第一栏价格
      tabs_isa: "", //第二栏价格
      tabs_isaa: "", //第三栏价格

      hpria: "", //第一栏回收单价
      hprib: "", //第二栏回收单价
      hpric: "", //第三栏回收单价

      reaprice1: "", //第一栏上交所单价
      reaprice2: "", //第二栏上交所单价
      reaprice3: "", //第三栏上交所单价

      hs_ze: "", //第一栏折当率
      hs_zea: "", //第二栏折当率
      hs_zeaa: "", //第三栏折当率

      inputzf: "", //支付备注

      tabs_inputs: "", //第一栏当物名称
      tabs_inputsa: "", //第二栏当物名称
      tabs_inputsaa: "", //第三栏当物名称

      deta: "", //建当日期
      finance: "", //财务
      review: "", //复核
      agent: "", //经办人
      token: "", //token

      daydate: "", //复核的日期（今天的日期）
    };
  },
  methods: {
    //   提交的方法
    cont_Submits() {
      this.$confirm("是否要复核订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("take_back").doc("${this.id}").update({data:{input_pnum:"${this.input_pnum}",input_names:"${this.input_names}",input_idcards:"${this.input_idcards}",
                input_tels:"${this.input_tels}",input_adds:"${this.input_adds}",input_wus:"${this.input_wus}",inputzf:"${this.inputzf}",review:"${this.review}",tabs_inps:"${this.tabs_inps}",
                tabs_inpus:"${this.tabs_inpus}",tabs_inputs:"${this.tabs_inputs}",tabs_ins:"${this.tabs_ins}",tabs_is:"${this.tabs_is}",agent:"${this.agent}",reaprice1:"${this.reaprice1}",
                hpria:"${this.hpria}",hs_ze:"${this.hs_ze}",tabs_inputsa:"${this.tabs_inputsa}",tabs_inpusa:"${this.tabs_inpusa}",tabs_inpsa:"${this.tabs_inpsa}",tabs_insa:"${this.tabs_insa}",
                tabs_isa:"${this.tabs_isa}",reaprice2:"${this.reaprice2}",hprib:"${this.hprib}",hs_zea:"${this.hs_zea}",tabs_inputsaa:"${this.tabs_inputsaa}",tabs_inpusaa:"${this.tabs_inpusaa}",
                tabs_inpsaa:"${this.tabs_inpsaa}",tabs_insaa:"${this.tabs_insaa}",tabs_isaa:"${this.tabs_isaa}",reaprice3:"${this.reaprice3}",hpric:"${this.hpric}",hs_zeaa:"${this.hs_zeaa}",
                whether:true,reviewdate:"${this.daydate}"}})`,
            })
            .then((refs) => {
              if (refs.data.errcode == 0) {
                this.sendOrders();

                this.$notify({
                  title: "复核成功",
                  message: "该订单已复核成功",
                  type: "success",
                });
                this.addjl();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: "请检查token是否过期",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复核",
          });
        });
    },
    //发送新工单微信模板消息
    sendOrders() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weReviewTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

           if(res.data.errcode == 0){
               this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("weTemplate").where({}).get()`,
              })
              .then((re) => {
                re.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });
             
              this.axios.get("/getToken/GetTokenGZH",{
                  params:{
                  "id":re.data.data[0].gzhTokenID,
                  "appid":re.data.data[0].mpappid,
                  "secret":re.data.data[0].secret
                  }
                })
                .then(r=>{
                
                  this.sendReview(res.data.data,r.data[0].AccessToken)


                })
                 
              })
          }


         
        });
    },
    //发送新工单
    sendReview(event,token){
       for (let i = 0; i < event.length; i++) {

            util.sendOrder(
              dayjs().format("YYYY-MM-DD HH:mm:ss"),
              "同意绝当回收",
              this.input_names,
              "(回收)",
              this.input_pnum,
              `复核人:${this.review}同意审批回收`,
              token,
              event[i]
            );

          }
    },
    //请求数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("take_back").doc("' + this.id + '").get()',
        })
        .then((rs) => {
          if (rs.data.errcode !== 0) {
            return this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
          rs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          // console.log(rs.data.data)
          this.deta = rs.data.data[0].deta;
          this.input_pnum = rs.data.data[0].input_pnum;
          this.input_names = rs.data.data[0].input_names;
          this.input_adds = rs.data.data[0].input_adds;
          this.input_idcards = rs.data.data[0].input_idcards;

          this.input_tels = rs.data.data[0].input_tels;
          this.input_wus = rs.data.data[0].input_wus; //物品类型

          this.tabs_inpus = rs.data.data[0].tabs_inpus; //第一栏物品规格种类
          this.tabs_inpusa = rs.data.data[0].tabs_inpusa; //第二栏物品种类规格
          this.tabs_inpusaa = rs.data.data[0].tabs_inpusaa; //第三栏物品种类规格

          this.tabs_inps = rs.data.data[0].tabs_inps; //第一栏数量
          this.tabs_inpsa = rs.data.data[0].tabs_inpsa; //第二栏数量
          this.tabs_inpsaa = rs.data.data[0].tabs_inpsaa; //第三栏数量

          this.tabs_ins = rs.data.data[0].tabs_ins; //第一栏重量
          this.tabs_insa = rs.data.data[0].tabs_insa; //第二栏重量
          this.tabs_insaa = rs.data.data[0].tabs_insaa; //第三栏重量

          this.tabs_is = rs.data.data[0].tabs_is; //第一栏价格
          this.tabs_isa = rs.data.data[0].tabs_isa; //第二栏价格
          this.tabs_isaa = rs.data.data[0].tabs_isaa; //第三栏价格

          this.inputzf = rs.data.data[0].inputzf; //备注

          this.tabs_inputs = rs.data.data[0].tabs_inputs; //第一栏物品名称
          this.tabs_inputsa = rs.data.data[0].tabs_inputsa; //第二栏物品名称
          this.tabs_inputsaa = rs.data.data[0].tabs_inputsaa; //第三栏物品名称

          this.agent = rs.data.data[0].agent;

          this.hpria = rs.data.data[0].hpria; //第一栏回收单价
          this.hprib = rs.data.data[0].hprib; //第二栏回收单价
          this.hpric = rs.data.data[0].hpric; //第三栏回收单价

          this.reaprice1 = rs.data.data[0].reaprice1; //上交所第一栏单价
          this.reaprice2 = rs.data.data[0].reaprice2; //上交所第二栏单价
          this.reaprice3 = rs.data.data[0].reaprice3; //上交所第三栏单价

          this.hs_ze = rs.data.data[0].hs_ze; //第一栏折当率
          this.hs_zea = rs.data.data[0].hs_zea; //第二栏折当率
          this.hs_zeaa = rs.data.data[0].hs_zeaa; //第三栏折当率
        });
    },

    //添加记录
    addjl() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${this.input_names}",xuday:"${this.daydate}",itemname:"${this.tabs_inputs}",ticketnumber:"${this.input_pnum}",telnumber:"${this.input_tels}",xupri:"0",enddate:"/",dday:"/",xuname:"${this.review}",overdate:"/",ytdy:"0",pena:"0",rece:"${this.tabs_is}",stas:"回收",pri:"${this.tabs_is}",lx:"0",yspri:"${this.tabs_is}",couqons:"不适用",couqonmoney:"0",weight:"${(Number(this.tabs_ins)+Number(this.tabs_insa)+Number(this.tabs_insaa)).toFixed(2)}",cardnumber:"${this.input_idcards}",agent:"${this.agent}",review:"${this.review}",finance:""}})`,
        })
        .then((rcc) => {
          if (rcc.data.errcode == 0) {
            this.$router.push("/review");
          }
        });
    },
  },
  // 生命周期函数，监听挂载
  created() {
    //id
    this.id = this.$route.query.id;
    //ACCESS_TOKEN
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //复核的日期（今天的日期）
    this.daydate = dayjs().format("YYYY-MM-DD");
  },
  //生命周期函数监听页面挂载成功
  mounted() {
    setTimeout(() => {
      this.getData();

      //获取复核人姓名
      this.review = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
/* 断当回收样式 */
.cont_box {
  width: 95%;
  height: 95%;
  background-color: #ffffff;
  margin: 50px auto;
}
.cont_head {
  width: 100%;
  height: 40px;
  background-color: #eeeeed;
  box-shadow: 0 0 9px 0 #00000044;
  border: 1px solid #c5c5c5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.cont_head h2 {
  margin: 3px 30px;
}
.bord {
  border: 0.5px solid #c5c5c5;
  margin-top: 4px;
}
.cont_bo {
  width: 100%;
  height: 95%;
  border: 1px solid #c5c5c5;
  /* box-shadow: 0 0 3px 0 #000000; */
}
.cont_b {
  width: 100%;
  height: 99%;
  border: 1px solid #c5c5c5;
  margin: 4px auto;
  box-shadow: 0 0 9px 0 #00000044;
}
.tab_item {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.cont_jb {
  margin: 10px 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.cont_left {
  width: 50%;
}
.cont_right {
  width: 50%;
}
.con_texts {
  width: 50%;
}
.tables {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}
.cont_contes {
  width: 95%;
  border: 1px solid #8f8f8fdc;
  box-shadow: 0 0 9px 0 #00000044;
  margin: 45px auto;
}
.cons_cos {
  display: flex;
  flex-direction: row;
}
.cont_lefts {
  width: 50%;
  margin: 40px 80px;
}
.cont_rights {
  width: 50%;
  margin: 40px 0px;
}
.conts_zf {
  margin: 40px 0;
  display: flex;
  flex-direction: row;
}
.conts_zf h3 {
  margin: 10px 25px;
  width: 40%;
}
.cont_zfin {
  width: 98%;
}
.foter {
  margin: 30px 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tab_ces {
  display: flex;
  flex-direction: row;
}

/* 新版回收复核页面 */
table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  font-size: 15px;
  text-align: center;
}
td input {
  outline: none;
  border: 0;
  color: #c44257;
  width: 95%;
  height: 100%;
  font-size: 15px;
  text-align: center;
}
</style>
